import axios from 'axios';

// POST /candidate/invitation { candidateId } — reuses the existing resend-invitation flow
// (re-sends the onboarding invite email). Requires a candidateId, which the Users list does
// not carry, so the caller resolves it from /admin/candidates first (see getAdminCandidates).
export async function resendInvite(candidateId) {
  try {
    const res = await axios.post('/candidate/invitation', { candidateId });
    return { ok: res.data && res.data.status === 'SUCCESS' };
  } catch (error) {
    const data = error.response && error.response.data;
    return { ok: false, message: (data && data.status_message) || 'Failed to resend invitation.' };
  }
}
